import {
  addDays,
  format,
  isAfter,
  isFuture,
  lastDayOfMonth,
  startOfDay,
  startOfMonth,
  subMonths,
} from "date-fns";
import _ from "lodash";
import moment from "moment";

export const toMoment = (date) => {
  return !!date && _.isDate(date) ? moment(date.toISOString()) : undefined;
};

export const startLastMonth = () =>
  toMoment(startOfMonth(subMonths(new Date(), 1)));

export const currentDateMoment = () => toMoment(new Date());

export const addCurrentDateMoment = (numDay) =>
  toMoment(addDays(new Date(), numDay || 0));

export const endMonthCurrent = () => toMoment(lastDayOfMonth(new Date()));

export const currentTime_yyyyMMddhhMMss = () =>
  format(new Date(), "yyyyMMddHHMMss");

  export const currentTime_yyyyMMdd = () =>
  format(new Date(), "yyyyMMdd");

export const currentTime_ddMMyyyyhhMM = () =>
  format(new Date(), "ddMMyyyyhhMM");

export const currentTime_MMyyyy = () => format(new Date(), "MMyyyy");

export const currentLastMonth = () =>
  toMoment(addDays(subMonths(new Date(), 1), 1));

export const formatDateStr_DDMMYYYYHHmmss = (str) =>
  str ? moment(new Date(str)).format("DD/MM/YYYY HH:mm:ss") : "";

export const momentToPayload_yyyyMMDD = (dateMoment) =>
  dateMoment ? moment(dateMoment).format("yyyy/MM/DD") : null;

export const momentToPayload_MMyyyy = (dateMoment) =>
  dateMoment ? moment(dateMoment).format("MM/yyyy") : null;

export const disableFuture = (current) => {
  return (
    isFuture(current.toDate()) ||
    isAfter(startOfDay(new Date(1990, 0, 1)), current.toDate())
  );
};
export function isDate(dateStr) {
  return !isNaN(new Date(dateStr).getDate());
}
export const formatMomentSearchForm = (dateMoment) =>
  dateMoment.format("DD/MM/YYYY");

export const formatStringToMoment = (str) => {
  if (_.isNil(str) || _.isEmpty(str)) return undefined;
  return moment(str, "DD/MM/YYYY");
};

export const momentToStringRequestParam = (v) =>
  moment.isMoment(v) ? v.format("DD/MM/YYYY") : v;
